import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { FascicleService } from '../services/fascicle.service';

export const FascicleFormEditResolver: ResolveFn<any> = async (route) => {
  const idCatalog = route.paramMap.get('idCatalog');
  const id = route.paramMap.get('id');
  try {
    return await inject(FascicleService).getBreadCrumbFascicleEdit(idCatalog, id);
  } catch {
    return [];
  }
};
